export default __webpack_public_path__ + "static/cardTabImg2-004c2fa9144a16b38e71650f2fc9ff7b.webp";